import main from './main';
import plugins from './plugins';
import managers from './managers';
export default {
  ...main,
  ...plugins,
  ...managers,
}
